import React, { useState } from 'react'
import ConfirmModal from './Childs/ConfirmModal'
import TableCheckBox from './Childs/TableCheckBox'
import { refreshWarehouse } from './ZohoInventoryCommonFunc'

export default function ZohoInventorySalesActions({ wcInventoryConf, setWcInventoryConf,isLoading, setisLoading, setSnackbar  }) {
  const [actionModel, setActionModel] = useState(false)
  const actionHandler = (val, typ, checked) => {
    const newConf = { ...wcInventoryConf }
    if (!newConf.actions.inventorySales) newConf.actions.inventorySales = {}
    if (checked) {
      newConf.actions.inventorySales[typ] = val
    } else {
      delete newConf.actions.inventorySales[typ]
    }
    if (typ === 'warehouse') {
      if (checked) {
        newConf.actions.inventorySales[typ] = val
        setActionModel(true)
      } else {
        setActionModel(false)
        newConf.actions.inventorySales[typ] = false
      }
    }

    setWcInventoryConf({ ...newConf })
  }

  const closeModel = () => {
    setActionModel(false)
  }
  const handleOption = (e) => {
    const newConf = { ...wcInventoryConf }
    const { name, value } = e.target      
    if (value !== '') {
      newConf.actions.inventorySales[name] = value
    }else{
      delete  newConf.actions.inventorySales[name]
    }
    setWcInventoryConf(newConf)
  }

  return (
  <>
    <div className="pos-rel">
      <div className="d-flx flx-wrp w-10">
        <TableCheckBox onChange={e => actionHandler('completed', 'status', e.target.checked)} checked={wcInventoryConf?.actions?.inventorySales?.status} className="wdt-200 mt-4 mr-2" value="Completed" title="Status Completed" subTitle="Change sales order status to completed in zoho inventory. By default, it will be saved as draft." />
      <TableCheckBox onChange={e => actionHandler(true , 'warehouse', e.target.checked)} checked={wcInventoryConf?.actions?.inventorySales?.warehouse} className="wdt-200 mt-4 mr-2" value="Completed" title="Add Warehouse" subTitle="Select to add Warehouse and Salesperson" />
      </div>
    
    </div>

   <ConfirmModal
        className="custom-conf-mdl"
        mainMdlCls="o-v"
        btnClass="blue"
        btnTxt='Ok'
        show={actionModel === true}
        close={closeModel}
        action={closeModel}
        title='Warehouse'
      >
        <div className="btcd-hr mt-2 mb-2" />
        <div className="p-1">
          <div className="my-2 w-10">
            Warehouse Name
            <button onClick={() => refreshWarehouse(wcInventoryConf, setWcInventoryConf, setisLoading, setSnackbar)} className="icn-btn sh-sm ml-2 mr-2 tooltip" style={{ '--tooltip-txt': '"Refresh Organization"' }} type="button" disabled={isLoading}>&#x21BB;</button>
          </div>
          <select  value={wcInventoryConf.actions.inventorySales.warehouseId} name="warehouseId"onChange={handleOption} className="btcd-paper-inp w-10 mx-0">
            <option value="">Select warehouse </option>
            {
              wcInventoryConf.default.warehouses && wcInventoryConf.default.warehouses.map(warehouse => (
                <option key={warehouse.warehouse_id} value={warehouse.warehouse_id}>
                  {warehouse.warehouse_name}
                </option>
              ))
            }
          </select>
        </div>

        <div className="p-1">
          <div className="my-2 w-10">
            Salesperson Name
          </div>
          <select  value={wcInventoryConf.actions.inventorySales.salespersonId} name="salespersonId"onChange={handleOption} className="btcd-paper-inp w-10 mx-0">
            <option value="">Select Salesperson </option>
            {
              wcInventoryConf.default.salespersons && wcInventoryConf.default.salespersons.map(salesperson => (
                <option key={salesperson.salesperson_id} value={salesperson.salesperson_id}>
                  {salesperson.salesperson_name}
                </option>
              ))
            }
          </select>
        </div>

      </ConfirmModal>
  </>
  )
}
